import { render, staticRenderFns } from "./GlobalIndicatorsCategoryBanner.vue?vue&type=template&id=4a7a7f15&"
import script from "./GlobalIndicatorsCategoryBanner.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsCategoryBanner.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalIndicatorsCategoryBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports